export default "__VITE_ASSET__C1p7O0ur__"